import { OnlineSourceData } from './OnlineSourceModal';

export const getCanStartCrawl = (onlineSource: OnlineSourceData) => {
  return Boolean(
    onlineSource.is_active &&
      onlineSource.combined_status &&
      ['setup', 'completed', 'failed', 'cancelled', 'cancel_pending'].includes(
        onlineSource.combined_status
      )
  );
};
